import styled, { keyframes } from 'styled-components';
import { Box, Text } from '@rsos/base-components';
import { EVENT_PANE_MARGIN } from '../../../EventPane.styles';

const glow = keyframes`
  0% {
    --gradient-angle: 0deg;
  }
  100% {
    --gradient-angle: 360deg;
  }
`;

export const LinearGradientBox = styled.div`
  display: flex;
  align-self: center;
  position: relative;
  width: 100%;
  padding: 1px;
  background: linear-gradient(
    -175deg,
    #ed25c1 0%,
    #a74fff 21%,
    #f096ff 33%,
    #ebcbe4 53%,
    #dec2d8 56%,
    #ef40be 78%,
    #874fff 89%,
    #4d25ed 100%
  );
  border-radius: 5px;
  box-sizing: border-box;
`;

export const ConicGradientBox = styled.div`
  width: 100%;

  @property --gradient-angle {
    syntax: '<angle>';
    initial-value: 90deg;
    inherits: false;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    ${({ isGlowVisible }) =>
      isGlowVisible &&
      `
        background: conic-gradient(
          from var(--gradient-angle),
          #ed25c1 0%,
          #a74fff 21%,
          #f096ff 33%,
          #ebcbe4 53%,
          #dec2d8 56%,
          #ef40be 78%,
          #874fff 89%,
          #4d25ed 100%
        );
      `}

    filter: blur(12px);
    animation: ${glow} 2.5s linear infinite;
  }
`;

export const IncidentBox = styled(Box).attrs({
  position: 'relative',
  width: '100%',
  padding: '16px',
  backgroundColor: 'background',
  borderRadius: '5px',
  overflow: 'hidden',
})``;

export const IncidentHeader = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  justify: 'space-between',
  marginBottom: `${EVENT_PANE_MARGIN}px`,
})`
  position: relative;
`;

export const IncidentContent = styled(Text).attrs({
  size: 'normal',
  color: 'secondaryText',
  lineHeight: '125%',
})``;

export const PoweredByHarmonyWrapper = styled(Box).attrs({
  padding: '0px',
  width: '100%',
  transition: 'padding-right 0.2s ease-out',
})`
  ${LinearGradientBox}:hover & {
    padding-right: calc(32px + 8px);
  }
`;

export const CopySummaryWrapper = styled(Box).attrs({
  position: 'absolute',
  transition: 'transform 0.2s ease-out, opacity 0.2s ease-out',
})`
  right: 0;
  transform: translateX(100%);
  opacity: 0;

  ${LinearGradientBox}:hover & {
    transform: translateX(0);
    opacity: 1;
  }
`;
